module.exports = __webpack_public_path__ + "static/nasa4-98c25eaca8cbba347aeba7b0be06de04.gif";